export const getWishlistId = async ({
    wishlist,
    customerId,
    refetchWishlist,
    createCustomerProductList
}) => {
    if (wishlist?.id) return wishlist.id
    if (!customerId) return null

    try {
        const result = await refetchWishlist?.()
        const lists = result?.data?.data || []
        const existing = lists.find((list) => list.type === 'wish_list')
        if (existing?.id) return existing.id
    } catch (error) {
        console.warn('Unable to refetch wishlist lists', error)
    }

    try {
        const created = await createCustomerProductList({
            parameters: {customerId},
            body: {type: 'wish_list'}
        })
        return created?.id || created?.data?.id || null
    } catch (error) {
        console.warn('Unable to create wishlist', error)
        return null
    }
}

// Detects the backend hook signal returned by customerProductListItemsHooks.beforePOST
// when the wishlist limit (set via the `wishlistMaxItemsCount` site preference) is reached.
export const isWishlistMaxItemsReachedError = async (error) => {
    try {
        const response = error?.response
        if (!response) return false
        // Clone before reading so the original body stream stays consumable for any other handler.
        const cloned = typeof response.clone === 'function' ? response.clone() : response
        const body = await cloned.text()
        return body.includes('MAX_ITEMS_REACHED')
    } catch {
        return false
    }
}
